import React, { Component } from 'react';

const SCRIPT_ID = 'cf-turnstile-script';
const SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

function loadTurnstileScript() {
  if (typeof window === 'undefined') return Promise.resolve();
  if (window.turnstile) return Promise.resolve();

  const existing = document.getElementById(SCRIPT_ID);
  if (existing) {
    return new Promise((resolve) => {
      if (window.turnstile) {
        resolve();
        return;
      }
      existing.addEventListener('load', () => resolve(), { once: true });
    });
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Cloudflare Turnstile'));
    document.head.appendChild(script);
  });
}

class Turnstile extends Component {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
    this.widgetId = null;
  }

  componentDidMount() {
    this.mountWidget();
  }

  componentWillUnmount() {
    this.removeWidget();
  }

  removeWidget = () => {
    if (this.widgetId != null && window.turnstile) {
      try {
        window.turnstile.remove(this.widgetId);
      } catch (e) {
        // ignore
      }
      this.widgetId = null;
    }
  };

  mountWidget = async () => {
    const { sitekey, onVerify, onExpire, onError } = this.props;
    if (!sitekey || !this.containerRef.current) return;

    try {
      await loadTurnstileScript();
      if (!window.turnstile || !this.containerRef.current) return;

      this.removeWidget();
      this.widgetId = window.turnstile.render(this.containerRef.current, {
        sitekey,
        callback: (token) => {
          if (onVerify) onVerify(token);
        },
        'expired-callback': () => {
          if (onExpire) onExpire();
        },
        'error-callback': () => {
          if (onError) onError();
        },
      });
    } catch (e) {
      if (onError) onError(e);
    }
  };

  reset = () => {
    if (this.widgetId != null && window.turnstile) {
      window.turnstile.reset(this.widgetId);
    }
  };

  render() {
    return <div ref={this.containerRef} className={this.props.className || ''} />;
  }
}

export default Turnstile;
